<template>
  <main id="home">
    <hero/>
    <featured-in/>
    <reasons-invest/>
    <image-carousel/>
    <invest-entrepreneurship/>
    <keep-local/>
    <cta
    background='cta/cta1.jpeg'
    message='Navigating the uncharted waters of the $25 billion cannabis industry is hard. <br> We simplify it.'
    button_action='https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view'
    button_text='Invest Now'
     />
    <grow-together />
    <labs-advantage/>
    <our-story/>
    <story-testimonial/>
    <investment-data />
    <faqs />
    <cta
    background='cta/cta2.jpeg'
    message='Keeping cannabis local creates jobs.<br>
Builds community. Supports families.<br>
Protects businesses.'
    button_action='https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view'
    button_text='Invest Now'
     />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Cta from '@/components/cta.vue';
import Faqs from '@/components/faqs.vue';
import InvestmentData from '@/components/investment-data.vue';
import Hero from '@/components/Hero.vue'
import FeaturedIn from '@/components/FeaturedIn.vue'
import ReasonsInvest from '@/components/ReasonsInvest.vue'
import ImageCarousel from '@/components/ImageCarousel.vue'
import InvestEntrepreneurship from '@/components/InvestEntrepreneurship.vue'
import KeepLocal from '@/components/KeepLocal.vue';
import GrowTogether from '@/components/GrowTogether.vue';
import OurStory from '@/components/OurStory.vue';
import LabsAdvantage from '@/components/LabsAdvantage.vue';
import StoryTestimonial from '@/components/StoryTestimonial.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    Cta,
    Faqs,
    InvestmentData,
    Hero,
    FeaturedIn,
    ReasonsInvest,
    ImageCarousel,
    InvestEntrepreneurship,
    KeepLocal,
    GrowTogether,
    OurStory,
    LabsAdvantage,
    StoryTestimonial
  },
  methods: {
  },
  mounted() {
  },
};
</script>
